import { MdDragIndicator } from 'react-icons/md';
import { Question } from 'api/questions/types';
import { SectionBlock } from 'utils/examScenario';
import { ExamQuestionRow } from './ExamQuestionRow';
import { DraggableProvided } from 'react-beautiful-dnd';

interface Props {
  block: SectionBlock;
  sectionQuestions: Question[];
  sIndex: number;
  dragHandleProps: DraggableProvided['dragHandleProps'];
  onEdit: (q: Question) => void;
  onDelete: (sIndex: number, questionId: string) => void;
}

export function ExamSingleQuestionBlock({
  block,
  sectionQuestions,
  sIndex,
  dragHandleProps,
  onEdit,
  onDelete
}: Props) {
  const question = block.questions[0];
  if (!question) return null;

  const foundIndex = sectionQuestions.findIndex((qq) => qq._id === question._id);
  const displayIndex = foundIndex >= 0 ? foundIndex + 1 : 1;

  return (
    <div
      className="grid items-center gap-4 w-full"
      style={{ gridTemplateColumns: '1fr auto' }}
    >
      <ExamQuestionRow
        question={question}
        displayIndex={displayIndex}
        dragHandleProps={dragHandleProps}
        onEdit={onEdit}
        onDelete={() => onDelete(sIndex, question._id)}
      />
    </div>
  );
}
